import {FileManagerLocation, IconViewModel} from '../../models/file-manager.model';
import {
  FileManagerActions,
  SELECTION_CHANGED,
  FileSelectionChangedAction,
  SET_CURRENT_LOCATION,
  GRID_ITEM_SELECTION_CHANGED,
  FileGridItemSelectionChangedAction,
  ADD_GRID_ITEM_TO_SELECTION,
  AddGridItemToSelectionAction, REMOVE_GRID_ITEM_FROM_SELECTION, RemoveGridItemFromSelectionAction
} from '../actions/file-manager.actions';

export interface FileManagerState {
  currentLocation: FileManagerLocation;
  selectedItems: IconViewModel[];
  selectedGridItems: any[];
}

const initialState: FileManagerState = <FileManagerState> {
  currentLocation: new FileManagerLocation(<FileManagerLocation>{
    fullRelativePath: '',
    relativePaths: [],
    parentIds: [],
    fileNames: [],
  }),
  selectedItems: [],
  selectedGridItems: []
};


export function FileManagerReducer (state = initialState, action: FileManagerActions) {
  switch (action.type) {
    case SELECTION_CHANGED:
      const selectedItems = (action as FileSelectionChangedAction).selectedItems;
      return {
        ...state,
        selectedItems
      };
    case GRID_ITEM_SELECTION_CHANGED:
      const selectedGridItems = (action as FileGridItemSelectionChangedAction).selectedGridItems;
      return {
        ...state,
        selectedGridItems: [...selectedGridItems]
      };
    case ADD_GRID_ITEM_TO_SELECTION:
      const addedItems =  (action as AddGridItemToSelectionAction).selectedGridItems;
      return {
        ...state,
        selectedGridItems: state.selectedGridItems.concat(addedItems)
      };
    case REMOVE_GRID_ITEM_FROM_SELECTION:
      const deselectedRows = (action as RemoveGridItemFromSelectionAction).deselectedGridItems;
      const selectedList = state.selectedGridItems.filter( (selectedListItem) =>
        !deselectedRows.some(deselectedItem => deselectedItem.dataItem.id === selectedListItem.dataItem.id));
      return {
        ...state,
        selectedGridItems: selectedList
      };
    case (SET_CURRENT_LOCATION):
      let newLocation: FileManagerLocation;
      if (action.parentId === 'Root') {
        newLocation =  new FileManagerLocation(<FileManagerLocation>{
          fullRelativePath: '',
          relativePaths: [],
          parentIds: [],
          fileNames: []
        });
      } else {
        newLocation = state.currentLocation;
      }
      const fullRelativePath = action.fullRelativePath;
      const parentId = action.parentId;
      const relativePaths = fullRelativePath.split('\\');
      const fileName = action.fileName;
      if (newLocation.parentIds.indexOf(parentId) < 0) {
        newLocation.parentIds.push(parentId);
        newLocation.fileNames.push(fileName);
        const idx = newLocation.parentIds.indexOf(parentId);
        newLocation.relativePaths = relativePaths;
        newLocation.relativePaths.length = idx + 1;
        newLocation.fullRelativePath = fullRelativePath;
        return {
          ...state,
          currentLocation: newLocation
        };
      } else {
        const idx = newLocation.parentIds.indexOf(parentId);
        newLocation.fullRelativePath = fullRelativePath;
        newLocation.parentIds.length = idx + 1;
        newLocation.relativePaths.length = idx + 1;
        newLocation.fileNames.length = idx + 1;
        return {
          ...state,
          currentLocation: newLocation
        };
      }
    default:
      return state;
  }
}

